import React, {Component, Fragment} from 'react';
import {connect} from "react-redux";
import utilityActions from "../actions/utility-actions";
import withVfRouting from "../util/withVFRouting";
import _ from "lodash";

class WindowWatcher extends Component {

  constructor(props) {
    super(props);
    this.updateDimensions = _.debounce(this.updateDimensions.bind(this), 100);
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
    this.updateDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
    this.updateDimensions.cancel();
  }

  updateDimensions(){
    if (this.props.setAppWindowDimensions && document.body) {
      this.props.setAppWindowDimensions(document.body.getBoundingClientRect());
    }
  }

  render(){
    return null;
  }
}

const mapStateToProps = (state) => {
  return {
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    setAppWindowDimensions:(dimensions) => dispatch(utilityActions.setAppWindowDimensions(dimensions)),
  };
};

WindowWatcher.propTypes = {

}

export default withVfRouting(connect(mapStateToProps, mapDispatchToProps)(WindowWatcher));
